"use client"
import {
  LineChart
} from "./chunk-ZWA4FO4Q.mjs";

// src/components/bar-chart.ts
import { mergeMultiStyle } from "@yamada-ui/core";
var BarChart = mergeMultiStyle(
  LineChart,
  {
    baseStyle: {
      activeBar: {},
      background: { fill: "transparent" },
      bar: {},
      cursor: { strokeDasharray: "5 5" }
    }
  }
)({ omit: ["dot", "activeDot"] });

export {
  BarChart
};
//# sourceMappingURL=chunk-CUSG2YVE.mjs.map